import React from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const ExportToExcel = ({ tableId, filename }) => {
  const exportTableToExcel = () => {
    const table = document.getElementById(tableId);
    if (!table) {
      alert("Table not found!");
      return;
    }

    // Convert table to a worksheet
    const worksheet = XLSX.utils.table_to_sheet(table);

    // Create a new workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "reports");

    // Write and save the file
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });

    saveAs(blob, `${filename}.xlsx`);
  };

  return (
    <button id="test-table-xls-button" className="exportBtn btn submit-btn" onClick={exportTableToExcel}>
      Export
    </button>
  );
};

export default ExportToExcel;